import { AbilityBuilder, Ability } from "@casl/ability";

// DEV/PREVIEW OVERRIDE — when true, every CASL ability check returns true so
// every gated UI element (sidebar items, admin pages, action buttons) is
// visible regardless of the user's backend role. Pair with the
// Flagsmith stub (src/utils/flagsmithStub.js) for full "everything on" mode.
// Flip to false to restore normal role-driven gating.
const ALLOW_ALL_PERMISSIONS = true;

const GetPermissions = (roles, isFromMarketplace) => {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (ALLOW_ALL_PERMISSIONS) {
    // CASL: `manage` is the wildcard verb, `all` is the wildcard subject.
    // This single rule satisfies every `ability.can(verb, subject)` query.
    can("manage", "all");
    return build();
  }

  const verbs = [
    "read",
    "create",
    "update",
    "delete",
    "invite",
    "launch",
    "subscribe",
    "manage",
    "cancel",
    "readmy",
    "updatemy"
  ];

  let listOfPermissions = [];

  if (isFromMarketplace) {
    can("manage", "all");
    return build();
  }

  roles?.forEach((role) => {
    role?.rules?.forEach((rule) => {
      let key, value;
      key = rule?.resource?.toLowerCase();
      if (rule?.resource === "*" && rule?.verbs?.[0] === "*") {
        value = "manage";
        key = "all";
      } else if (rule?.resource !== "*" && rule?.verbs?.[0] === "*") {
        verbs.forEach((item) => {
          listOfPermissions.push({ value: item, key });
        });
      } else {
        rule?.verbs?.forEach((item) => {
          listOfPermissions.push({ value: item, key });
        });
      }
      if (value) listOfPermissions.push({ value, key });
    });
  });

  listOfPermissions.forEach((item) => {
    if (item?.value === "delete" && item?.key === "users") {
      return;
    }
    can(item?.value, item?.key);
  });

  if (
    listOfPermissions.some(
      (obj) =>
        obj.key === "users" ||
        obj.key === "roles" ||
        obj.key === "serviceaccounts" ||
        obj.key === "imagegroups" ||
        obj.key === "stats" ||
        obj.key === "subscriptions" ||
        obj.key === "plans" ||
        obj.key === "ldap" ||
        obj.key === "invoices" ||
        obj.value === "manage"
    )
  ) {
    can("switch", "admin");
  } else cannot("switch", "admin");

  return build();
};

export default GetPermissions;
